import React from 'react';
import classnames from 'classnames';
import { get } from 'lodash';
import { withRouter } from 'react-router';
import { withLocalize, Translate } from 'react-localize-redux';
import { formatNumber } from '../../repiUtils';
import { repiDomain,  repiProductCategories } from '../../../../store/repiStore';
import { isEmpty, isNullOrUndefined, isString } from '../../../../store/storeFunctions';

import '../../repi.scss';

const TYPES = {
    money: "money",
    text: "text",
    array: "array"
};

class RepiContractHeader extends React.Component {
    state = {
        showHistory: true,
        page: 1
    };

    render() {
        const { contract, contractIndex, isSubject, isPlus, isInternalDataCorrection, isAnyDataCorrection } = this.props;

        return (
            <div className="repi-contract-header lpad-1-5 rpad-1-5">
                <table width="100%" className={classnames("repi-contract-table", {"open" : contract.isContractOpen})}>
                    <tbody>
                        <tr>
                            <td>
                                <div className={classnames("repi-contract-sequence-number", {"open" : contract.isContractOpen})}>{contractIndex}</div>
                            </td>
                            <td>
                                <div className="repi-subsection-header">
                                    {this.props.translate(`Repi.Report.PaymentHistory.Filter.ContractType.${contract.productCode}`)}
                                    {this.formatContractId(isInternalDataCorrection || isSubject, contract.contractId, contract.contributorContractId)}
                                    <sup style={{paddingLeft: "0.4em"}}>{contract.registry === 56 ? "CZ" : contract.registry === 202 ? "SK" : ""}</sup>
                                </div>
                            </td>
                            <td>
                                <div className="repi-contract-state">
                                    {contract.isContractOpen
                                        ? this.props.translate("Repi.Report.PaymentHistory.Contract.Open")
                                        : this.props.translate("Repi.Report.PaymentHistory.Contract.Close")}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="repi-contract">
                    <div className="repi-contract-description">
                        <div className="repi-data-table">
                            <div className="columns">
                                <div className="column is-half">
                                    {contract.productCategory === repiProductCategories.claimEnforcement && !isEmpty(contract.productOriginalCode) &&
                                        this.renderDataTableRow("Repi.Report.PaymentHistory.ProductOriginal",
                                            this.props.translate(`Repi.ProductType.${contract.productOriginalCode}`))}
                                    {(isPlus || contract.productCategory === repiProductCategories.claimEnforcement) && <>
                                        {this.renderDataTableRow( `Repi.Report.PaymentHistory.Contract.TotalAmount.${contract.productCategory}`,
                                            contract.totalAmount, TYPES.money)}
                                        {contract.productCategory !== repiProductCategories.regularPayment && this.renderDataTableRow(
                                            `Repi.Report.PaymentHistory.Contract.RemainingAmount.${contract.productCategory}`,
                                            contract.remainingAmount, TYPES.money)}
                                    </>}
                                    {this.renderDataTableRow("Repi.Report.PaymentHistory.Contract.OverdueAmount", contract.overdueAmount, TYPES.money)}
                                    {this.renderDataTableRow("Repi.Report.PaymentHistory.Currency", this.getCurrency(contract.currencyCode))}
                                    {isInternalDataCorrection && <>
                                        {this.renderDataTableRow("Repi.Other.ContributorId", contract.contributorId)}
                                        {this.renderDataTableRow("Repi.Other.ContributorContractId", contract.contributorContractId)}
                                    </>}
                                </div>
                                <div className="column is-half">
                                    {contract.productCategory === repiProductCategories.claimEnforcement &&
                                        this.renderDataTableRow("Repi.Report.PaymentHistory.RecallDate", contract.recallDateFormatted)}
                                    {!isAnyDataCorrection && <>
                                        {this.renderDataTableRow("Repi.Report.PaymentHistory.StartDate", contract.startDateFormatted)}
                                        {this.renderDataTableRow(`Repi.Report.PaymentHistory.EndDate${(contract.isContractOpen ? ".Expected" : "")}`,
                                            contract.endDateFormatted)}
                                    </>}
                                    {this.renderDataTableRow("Repi.Report.PaymentHistory.Status", this.getDunningLevel(contract.dunningLevelAliasId))}
                                    {this.renderDataTableRow("Repi.Report.PaymentHistory.Source", contract.publicContributorId)}
                                    {this.renderDataTableRow("Repi.Report.PaymentHistory.DebtBuyerId", contract.debtBuyerId)}
                                    {isAnyDataCorrection && !isNullOrUndefined(this.props.headerDataCorrection) && this.props.headerDataCorrection}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderDataTableRow = (title, text, dataType = TYPES.text) => {
        if (isNullOrUndefined(text) || isString(text) && text.length === 0)
            return null;

        if (dataType === TYPES.array && text.length === 0)
            return null;

        return (
            <div className="repi-data-table-item is-contract-header-item">
                <table width="100%" border="0">
                    <tbody>
                        <tr>
                            <td>
                                <div><Translate id={title} /></div>
                            </td>
                            <td>
                                <div>
                                    {dataType === TYPES.text && text}
                                    {dataType === TYPES.money && formatNumber(text, get(this.props, "activeLanguage.code"))}
                                    {dataType === TYPES.array && <span>
                                        {text.map((x, i) => i > 0 ? ` ,${x.value}` : x.value)}
                                    </span>}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    getDunningLevel = (dunningLevel) => {
        const result = this.getDomainData(repiDomain.dunningLevels, dunningLevel)
        return isNullOrUndefined(result) ? "" : this.props.translate(`Repi.DunningLevel.${result.shortening}`);
    }

    getCurrency = (code) => {
        const result = this.getDomainData(repiDomain.currencies, code)
        return isNullOrUndefined(result) ? "" : (result.shortening || "").toUpperCase();
    }

    getDomainData = (domain, value) => {
        if (isNullOrUndefined(value) || isNaN(parseInt(value)))
            return null;

        if (isNullOrUndefined(this.props.domain) || isNullOrUndefined(this.props.domain[domain]) ||
            isNullOrUndefined(this.props.domain[domain].requestResult))
            return null;

        return this.props.domain[domain].requestResult.find(f => parseInt(f.value) === parseInt(value));
    }

    formatContractId = (isContractId, contractId, contributorContractId) => {
        var ret = isContractId ? contractId : contributorContractId;
        return (isNullOrUndefined(ret) || ret === "") ? "" : ` ${this.props.translate("Repi.Report.PaymentHistory.ContractNumber.Short")}${ret}`;
    }
}

export default withLocalize(withRouter(RepiContractHeader));